import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ad-host]',
})
export class AdDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}




// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/ad.directive.ts